import React, { FC } from 'react';
import ItemsListWrapper from '@v2/pages/machines/common/wrappers/ItemsListWrapper/ItemsListWrapper';
import { ItemsListWrapperWithoutRenderProps, ItemWrapperProps } from '@v2/pages/machines/common/types/props';
import ItemOEETime from './ItemOEETime';

interface UtilizationItemsListProps extends ItemsListWrapperWithoutRenderProps {}

const UtilizationItemsList: FC<UtilizationItemsListProps> = (props) => {
  return <ItemsListWrapper {...props} getItemElement={({ item, C, selected }: ItemWrapperProps) => <ItemOEETime {...{ item, C, selected }} />} />;
};

export { UtilizationItemsList };
